<template>
  <div class="logo">
    <v-img :src="require('@/_static/img/LYB_logo.png')" contain></v-img>
  </div>
</template>

<script>
import userSettings from "@/_mixins/user-settings-mixin";
export default {
  name: "DialogScrollable",
  components: {},
  mixins: [userSettings],
  props: {},
  computed: {
    outerStyles() {
      var ret = {};
      ret["background-color"] = this.globalDarkMode
        ? "rgba(0,0,0,.5)"
        : "rgba(255,255,255,.6)";
      return ret;
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.logo {
  display: flex;
  height: 45px;
  width: 175px;
}
.logo > * {
  width: 100%;
}
</style>
